import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import AboutValues from './components/AboutValues';
import AboutStats from './components/AboutStats';
import AboutCTA from './components/AboutCTA';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://tadashiconsulting.co.za';

const aboutJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: 'About Tadashi Consulting – Luxury Renovation Experts Johannesburg',
    description:
      'Learn about Tadashi Consulting, a full-service renovation and construction partner in Johannesburg with over 10 years of experience delivering luxury residential and commercial transformations.',
    url: `${siteUrl}/about`,
    mainEntity: {
      '@type': 'HomeAndConstructionBusiness',
      name: 'Tadashi Consulting',
      foundingDate: '2014',
      numberOfEmployees: { '@type': 'QuantitativeValue', value: '20' },
      url: siteUrl,
      telephone: '+27118752075',
      email: 'info@tadashiconsulting.co.za',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '1 Wakis Road, Strydom Park, Block E 1',
        addressLocality: 'Randburg',
        addressRegion: 'Gauteng',
        postalCode: '2194',
        addressCountry: 'ZA',
      },
      areaServed: { '@type': 'City', name: 'Johannesburg' },
      sameAs: ['https://www.instagram.com/tadashi_interior_design'],
    },
  },
];

export default function AboutPage() {
  return (
    <main className="min-h-screen bg-white">
      <SeoHead
        title="About Tadashi Consulting – Luxury Renovation Experts Johannesburg"
        description="Discover the story behind Tadashi Consulting, Johannesburg's trusted luxury renovation and construction specialists. Over 10 years of expert craftsmanship, licensed contractors and 200+ completed projects across Gauteng."
        keywords="about Tadashi Consulting, luxury renovation company Johannesburg, construction experts Gauteng, licensed builders South Africa"
        canonical={`${siteUrl}/about`}
        ogTitle="About Tadashi Consulting – Luxury Renovation Experts Johannesburg"
        ogDescription="Over 10 years of expert craftsmanship, licensed contractors and 200+ completed luxury renovation projects across Johannesburg and Gauteng."
        jsonLd={aboutJsonLd}
      />
      <AboutHero />
      <AboutStory />
      <AboutValues />
      <AboutStats />
      <AboutCTA />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
